export enum TransactionType {
    Apvar = 1,
    Capvar = 2,
    Donation = 3,
    AdminEntry = 4,
    Reward = 5,
    Withdraw = 6,
    ApvarGroupOrderRebate = 7,
    CapvarGroupOrderRebate = 8,
    ApvarGroupOrderDepositDistribution = 9,
    CapvarGroupOrderDepositDistribution = 10,
    ApvarGroupOrderDepositReturn = 11,
    CapvarGroupOrderDepositReturn = 12,
    ApvarGroupOrderDepositPayment = 13,
    CapvarGroupOrderDepositPayment = 14,
    PvcGroupOrderDepositPayment = 15,
    PvcGroupOrderDepositDistribution = 16,
    PvcGroupOrderDepositReturn = 17,
    PvcGroupOrderRebate = 18,
    KpiGroupOrderDepositPayment = 19,
    KpiGroupOrderDepositDistribution = 20,
    KpiGroupOrderDepositReturn = 21,
    KpiGroupOrderRebate = 22,
    AccountingStandardizationL12GroupOrderDepositPayment = 23,
    AccountingStandardizationL12GroupOrderDepositDistribution = 24,
    AccountingStandardizationL12GroupOrderDepositReturn = 25,
    AccountingStandardizationL12GroupOrderRebate = 26,
    VirtualConferenceGroupOrderDepositPayment = 27,
    VirtualConferenceGroupOrderDepositDistribution = 28,
    VirtualConferenceGroupOrderDepositRefund = 29,
    VirtualConferenceGroupOrderRebate = 30,
    Kpi = 31,
    Pvc = 32,
    PmgPlacementFeeDeposit = 33,
    PmgPlacementFeeDepositRefund = 34,
    AccountingStandardizationL24GroupOrderDepositPayment = 35,
    AccountingStandardizationL24GroupOrderDepositDistribution = 36,
    AccountingStandardizationL24GroupOrderDepositReturn = 37,
    AccountingStandardizationL24GroupOrderRebate = 38,
    AccountingStandardizationL36GroupOrderDepositPayment = 39,
    AccountingStandardizationL36GroupOrderDepositDistribution = 40,
    AccountingStandardizationL36GroupOrderDepositReturn = 41,
    AccountingStandardizationL36GroupOrderRebate = 42,
    AccountingStandardizationYtdGroupOrderDepositPayment = 43,
    AccountingStandardizationYtdGroupOrderDepositDistribution = 44,
    AccountingStandardizationYtdGroupOrderDepositReturn = 45,
    AccountingStandardizationYtdGroupOrderRebate = 46,
    PmgAnnualSubscription = 47,
    InitialStandardizationL12MDepositCharge = 48,
    InitialStandardizationL24MDepositCharge = 49,
    InitialStandardizationL36MDepositCharge = 50,
    InitialStandardizationYtdDepositCharge = 51,
    MaintenanceStandardizationMonthlyDepositCharge = 52,
    MaintenanceStandardizationQuarterlyDepositCharge = 53,
    MaintenanceStandardizationSemiAnnuallyDepositCharge = 54,
    MaintenanceStandardizationAnnuallyDepositCharge = 55,
    InitialStandardizationL12MFinalPayment = 56,
    InitialStandardizationL24MFinalPayment = 57,
    InitialStandardizationL36MFinalPayment = 58,
    InitialStandardizationYtdFinalPayment = 59,
    MaintenanceStandardizationMonthlyFinalPayment = 60,
    MaintenanceStandardizationQuarterlyFinalPayment = 61,
    MaintenanceStandardizationSemiAnnuallyFinalPayment = 62,
    MaintenanceStandardizationAnnuallyFinalPayment = 63,
    PmgPlacementFeeRebate = 64,
    RefundStandardizationDeposit = 65,
    VirtualConferenceCharge = 66,
    VirtualConferenceRecordingAccess = 67,
    VirtualClipVideoAccess = 68,
    VideoClipCreationPayment = 69,
    CapvarDeposit = 71,
    CapvarDepositOverchargeRefund = 73,
    SendGiftCard = 74,
    ReceiveGiftCard = 75,
    IndirectReward = 76,
    ConvertRewardCreditsToFlex = 77,
    KnowledgeLibraryContent = 78,
    UserAnnualSubscriptionPayment = 79,
    UserMonthlySubscriptionPayment = 80,
    PayEngagementFinancialModelBuyerSelection = 81,
    PayEngagementIdNdaBuyerSelection = 82,
    PayEngagementDataNdaBuyerSelection = 83,
    IdNdaExecutionFee = 84,
    DataNdaExecutionFee = 85,
    FinancialModelDocumentAccessFee = 86,
    PayEngagementMonthlyRetainerFee = 87,
    PayEngagementSuspensionFee = 88,
    IdNdaBuyerSelectionRefund = 89,
    DataNdaBuyerSelectionRefund = 90,
    FinancialModelBuyerSelectionRefund = 91,
    EngagementLateFee = 92,
    EngagementDeadlineExtensionFee = 93,
    EngagementTempoChangeFee = 94,
    BuyerSellerEngagementMeetingFee = 95,
    BuyerSellerEngagementMeetingFeeRefund = 96,
    BuyerSellerEngagementMeetingFeeManualRefund = 97,
    EngagementMonthlyRetainerFeeRefund = 98,
}
